module.exports = __webpack_public_path__ + "static/media/pay_icon.5937df5c.svg";